import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Skeleton } from 'primereact/skeleton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import Conexao from '../../../providers/Conexao';
import Layout from '../../Layout';
import { Chart } from 'primereact/chart';
import { data, useLocation } from 'react-router-dom';
import { OverlayPanel } from 'primereact/overlaypanel';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Divider } from 'primereact/divider';
import { Tag } from 'primereact/tag';
import { InputSwitch } from "primereact/inputswitch";
import { SpeedDial } from 'primereact/speeddial';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import BotaoEditar from '../../../Componentes/BotaoEditar';
import BotaoExcluir from '../../../Componentes/BotaoExcluir';
import { Message } from 'primereact/message';
import { EXITED } from 'react-transition-group/Transition';
import TonerLevel from '../../../Componentes/TonerLevel';
import DashboardRevendaChatEquipamentos from './DashboardRevendaChatEquipamentos';
import { Chip } from 'primereact/chip';
export default function DashboardRevenda(props) {
    const toast = React.useRef(null); // Ref para o Toast

    const [visible, setVisible] = useState(false);

    const [loading, setLoading] = useState(false);
 
    const location = useLocation();

    const { dataEmpresa } = location.state || {};

    const [chartDCAData, setChartDCAData] = useState({});

    const [chartDCAOptions, setChartDCAOptions] = useState({});
   
    const [dataPainelProducao, setDataPainelProducao] = useState([])

    const [dataGraficoClientes, setDataGraficoClientes] = useState([])

    const [dataGraficoDCAs, setDataGraficoDCAs] = useState([])

    const [dataHistoricoEquipamentosLigados, setDataHistoricoEquipamentosLigados] = useState([])

    const [dataPrintersDashboardPainel, setDataPrintersDashboardPainel]= useState([])

    const [dataPainelColetas, setDataPainelColetas] = useState([])

    const firstConection = useRef(null)
    
    const [pronto, setPronto]= React.useState(0);

    const [atencao, setAtencao]= React.useState(0);

    const [alerta, setAlerta]= React.useState(0);

    const [offLine, setOffLine]= React.useState(0);

    const [total, setTotal]= React.useState(0);
    const [alertasSuprimentos, setAlertasSuprimentos] = useState([])
    const [dataPainelPrevisao, setDataPainelPrevisao] = useState([])


    const getDataPainelProducao = () =>{
        Conexao.get('dashboardController/getDataPainelProducao?idEmpresa='+dataEmpresa.idempresa+'&intervalo=0'+"&idcliente="+
            (dataEmpresa.idcliente ? dataEmpresa.idcliente : -1)
        )
        .then(response=>{
             if(response.status === 200 && response.data.status === 'OK'){
                setDataPainelProducao(response.data.payload)
             }
        })
        .catch(error =>{

        })
    }

    const getPainelPrevisao = () =>{
        Conexao.get('dashboardController/getPainelPrevisao?idEmpresa='+dataEmpresa.idempresa+'&intervalo=0'+"&idcliente="+
            (dataEmpresa.idcliente ? dataEmpresa.idcliente : -1)
        )
        .then(response=>{
             if(response.status === 200 && response.data.status === 'OK'){
     
                setDataPainelPrevisao(response.data.payload)
             }
        })
        .catch(error =>{

        })
    }


    const getPrintersDashboardPainel = () =>{
        Conexao.post('coletasController/getPrintersDashboardPainel', {
            idempresa : dataEmpresa.idempresa, 
            idcliente : dataEmpresa.idcliente ? dataEmpresa.idcliente : -1
        })
        .then(response=>{
             if(response.status === 200 && response.data.status === 'OK'){
                setPronto(response.data.payload.filter(item => item.status=='1').reduce(function(acumulador, item){
                    return acumulador + item.total;
                },0))

                setAtencao(response.data.payload.filter(item => item.status=='2').reduce(function(acumulador, item){
                    return acumulador + item.total;
                },0))

                setAlerta(response.data.payload.filter(item => item.status=='3').reduce(function(acumulador, item){
                    return acumulador + item.total;
                },0))

                setOffLine(response.data.payload.filter(item => item.status=='4').reduce(function(acumulador, item){
                    return acumulador + item.total;
                },0))
         
               setTotal( response.data.payload.reduce(function(a, b,){
                return a + b.total
             }, 0))
             }
        })
        .catch(error =>{

        })
    }

    
    const getDataGraficoClientes = () =>{
        
        Conexao.get('dashboardController/getDataGraficoClientes?idEmpresa='+dataEmpresa.idempresa+'&intervalo=0')
        .then(response=>{
            if(response.status === 200 && response.data.status === 'OK'){
                setDataGraficoClientes(response.data.payload)
            }
        })
        .catch(error =>{

        })
    }

    const getAlertaTonerSite = () =>{

        Conexao.post('coletasController/getAlertaTonerSite?idEmpresa='+dataEmpresa.idempresa+'&intervalo=0', {
            idempresa : dataEmpresa.idempresa, 
            idcliente : dataEmpresa.idcliente ? dataEmpresa.idcliente : -1
        })
        .then(response=>{
            if(response.status === 200 && response.data.status === 'OK'){
                setAlertasSuprimentos(response.data.payload)
            }
        })
        .catch(error =>{

        })
    }

    

    
    const getDataGraficoDCAs = () =>{
        Conexao.get('dashboardController/getDataGraficoDCAs?idEmpresa='+dataEmpresa.idempresa+'&intervalo=0'+"&idcliente="+dataEmpresa.idcliente)
        .then(response=>{
            if(response.status === 200 && response.data.status === 'OK'){
                setDataGraficoDCAs(response.data.payload)
            }
        })
        .catch(error =>{

        })
    }

    
    const getHistoricoEquipamentosLigados = () =>{
        Conexao.get('dashboardController/getHistoricoEquipamentosLigados?idEmpresa='+dataEmpresa.idempresa+'&intervalo=0'+"&idcliente="+dataEmpresa.idcliente)
        .then(response=>{
            if(response.status === 200 && response.data.status === 'OK'){
                setDataHistoricoEquipamentosLigados(response.data.payload.grafico)
            }else{

            }
        })
        .catch(error =>{

        })
    }

    
    const getPainelColetas = () =>{
        Conexao.get('dashboardController/getPainelColetas?idEmpresa='+dataEmpresa.idempresa+'&intervalo=0'+"&idcliente="+dataEmpresa.idcliente)
        .then(response=>{

        })
        .catch(error =>{

        })
    }

  
   useEffect(() => {
        if (!firstConection.current) {
             getDataGraficoClientes()
            getDataGraficoDCAs(); // aqui você faz o fetch e salva em setDataGraficoDCAs
            getHistoricoEquipamentosLigados()
            getDataPainelProducao()
           
            getPrintersDashboardPainel();
            getAlertaTonerSite();
            getPainelPrevisao();
            firstConection.current = true;
        }
    }, []);

useEffect(() => {
  if (dataGraficoDCAs.length === 0) return;

  const documentStyle = getComputedStyle(document.documentElement);

  const data = {
    labels: dataGraficoDCAs.map(item => item.case),
    datasets: [
      {
        data: dataGraficoDCAs.map(item => item.value),
        backgroundColor: [
          documentStyle.getPropertyValue('--green-500'),
          documentStyle.getPropertyValue('--red-500')
        ],
        hoverBackgroundColor: [
          documentStyle.getPropertyValue('--green-500'),
          documentStyle.getPropertyValue('--red-500')
        ]
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          usePointStyle: true
        }
      }
    }
  };

  setChartDCAData(data);
  setChartDCAOptions(options);
}, [dataGraficoDCAs]);


    const renderContentChip = (data) =>{

        switch(data.cor){
            case 'CIANO': return <div className='flex ' style={{width : '15%', marginTop : '5px', marginLeft : '3px', border: 'solid 0.8px #f2f2f2'}}>
                <div className='gradiente-warning spacing-center-vertical' style={{width :'20%', textAlign: 'center'}}>
                    <span style={{fontSize : '0.8rem', color: '#fff'}}>{data.nivelabertura+'%'}</span>
                </div>
                <div></div>
                
                <div style={{width :'80%', overflow:'hidden', paddingBottom : '2px', paddingTop : '2px'}} className='ellipsis'>
                    <div className="ml-1" style={{fontSize:'0.7rem', overflow:'hidden'}}>{data.numeroserie}</div>
                    <div className="ml-1" style={{fontSize:'0.5rem', overflow:'hidden'}}>{data.modelo}</div>
                </div>
                </div>
            case 'MAGENTA': return <div className='flex ' style={{width : '15%', marginTop : '5px', marginLeft : '3px', border: 'solid 0.8px #f2f2f2' }}>
                <div className='gradiente-error spacing-center-vertical' style={{width :'20%', textAlign: 'center'}}>
                    <span style={{fontSize : '0.8rem', color: '#fff'}}>{data.nivelabertura+'%'}</span>
                </div>
                <div></div>
                
                <div style={{width :'80%', overflow:'hidden', paddingBottom : '2px', paddingTop : '2px'}} className='ellipsis'>
                    <div className="ml-1" style={{fontSize:'0.7rem', overflow:'hidden'}}>{data.numeroserie}</div>
                    <div className="ml-1" style={{fontSize:'0.5rem', overflow:'hidden'}}>{data.modelo}</div>
                </div>
                </div>
            case 'AMARELO': return <div className='flex ' style={{width : '15%', marginTop : '5px', marginLeft : '3px', border: 'solid 0.8px #f2f2f2'}}>
                <div className='gradiente-warning spacing-center-vertical' style={{width :'20%', textAlign: 'center'}}>
                    <span style={{fontSize : '0.8rem', color: '#fff'}}>{data.nivelabertura+'%'}</span>
                </div>
                <div></div>
                
                <div style={{width :'80%', overflow:'hidden', paddingBottom : '2px', paddingTop : '2px'}} className='ellipsis'>
                    <div className="ml-1" style={{fontSize:'0.7rem', overflow:'hidden'}}>{data.numeroserie}</div>
                    <div className="ml-1" style={{fontSize:'0.5rem', overflow:'hidden'}}>{data.modelo}</div>
                </div>
                </div>
            case 'PRETO': return <div className='flex ' style={{width : '15%', marginTop : '5px', marginLeft : '3px', border: 'solid 0.8px #f2f2f2'}}>
                <div className='gradiente-default spacing-center-vertical' style={{width :'20%', textAlign: 'center'}}>
                    <span style={{fontSize : '0.8rem', color: '#fff'}}>{data.nivelabertura+'%'}</span>
                </div>
                <div></div>
                
                <div style={{width :'80%', overflow:'hidden', paddingBottom : '2px', paddingTop : '2px'}} className='ellipsis'>
                    <div className="ml-1" style={{fontSize:'0.7rem', overflow:'hidden'}}>{data.numeroserie}</div>
                    <div className="ml-1" style={{fontSize:'0.5rem', overflow:'hidden'}}>{data.modelo}</div>
                </div>
                </div>
           
        }
    }
        
    
    const showMessageToast = (severity, msg) => {
        switch(severity){
            case "error":
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "success":
                toast.current.show({
                    severity: "success",
                    summary: "Sucess",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

            case "warn":
                toast.current.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: msg,
                    life: 3000, // Tempo de exibição da notificação
                  });
            break;

        }
        
      };



    return (
        <Layout loading={loading}>
            <div className="p-5">
               <div className="flex flex-wrap ">
                    <div className="flex align-items-center col-12 md:col-2 " >
                        <div style={{width : '100%',textAlign:'center'}}>
                        <span style={{textAlign:'center'}}>Clientes Cadastrados</span>
                       <div style={{textAlign:'center'}}>
                            <span style={{fontSize:'6rem'}}>{ dataEmpresa.idcliente === -1 ? dataGraficoClientes.totalClientes : 1}</span>
                       </div>
                       
                       </div>
                    </div>
                    <div className="flex align-items-center col-12 md:col-2 " >
                        <div style={{width : '100%',textAlign:'center'}}>
                        <span style={{textAlign:'center'}}>Licenças Coleta</span>
                       <div style={{textAlign:'center'}}>
                            <span style={{fontSize:'5rem'}}>{dataEmpresa.idcliente > 0 ? 1 : (dataGraficoClientes.licencasCollectorAtivas && dataGraficoClientes.licencasCollectorInativas ) ? dataGraficoClientes.licencasCollectorAtivas + dataGraficoClientes.licencasCollectorInativas : null}</span>
                       </div>
                       <div className="flex " >
                          <Message text={dataGraficoClientes.licencasCollectorAtivas} className='w-50' style={{width : '48%', backgroundColor : 'var(--green-200)'}}/>
                          <Message text={dataGraficoClientes.licencasCollectorInativas} className='w-50 ml-2'style={{width : '48%', backgroundColor : 'var(--red-200)'}}/>
                       </div>
                       </div>
                    </div>

                    <div className="flex align-items-center col-12 md:col-2 " >
                        <div style={{width : '100%',textAlign:'center', height : '150px', }}>
                            <span style={{textAlign:'center'}}>DCA's</span>
                            <Chart type="pie" data={chartDCAData} options={chartDCAOptions} className="w-full h-full" />
                       
                        </div>
                    </div>
                    <div className="col-12 md:col-6 p-0"   >
                        <span className='text-xl'># Equipamento monitorados</span>
                       <div className="flex flex-wrap spacing-flex mt-4"  >
                            <div className='col-12 md:col-2 painel-status-equipamento-dash gradiente-info ml-1 '>
                                <div className='spacing-flex1' style={{color: '#fff'}}><i className='pi pi-print text-2xl' /><span className='ml-1' style={{fontSize:'1.5rem'}}>Total</span></div>
                                <div style={{textAlign:'center'}}><span  style={{fontSize:'3rem', fontWeight :'bold'}}>{total}</span></div>
                            </div>
                            <div className='col-12 md:col-2 painel-status-equipamento-dash gradiente-success ml-1'>
                                 <div className='spacing-flex1' style={{color: '#fff', display:'inline'}}><i className='pi pi-power-off text-2xl' /><span className='ml-1' style={{fontSize:'1.5rem'}}>OnLine</span></div>
                                <div  style={{textAlign:'center'}}><span className='ml-1' style={{fontSize:'3rem', fontWeight :'bold'}}>{pronto}</span></div>
                            </div>
                            <div className='col-12 md:col-2 painel-status-equipamento-dash gradiente-warning ml-1 '>
                                 <div className='spacing-flex1' style={{color: '#fff',  }}>
                                    <i className='pi pi-bell text-2xl' /><span className='ml-1' style={{fontSize:'1.5rem'}}>Atenção</span>
                                 </div>
                                <div  style={{textAlign:'center'}}><span style={{fontSize:'3rem', fontWeight :'bold'}}>{atencao}</span></div>
                            </div>
                            <div className='col-12 md:col-2 painel-status-equipamento-dash gradiente-error ml-1'>
                                 <div className='spacing-flex1' style={{color: '#fff'}}><i className='pi pi-exclamation-triangle text-2xl' /><span className='ml-1' style={{fontSize:'1.5rem'}}>Alertas</span></div>
                                <div  style={{textAlign:'center'}}><span  style={{fontSize:'3rem', fontWeight :'bold'}}>{alerta}</span></div>
                            </div>
                            <div className='col-12 md:col-2 painel-status-equipamento-dash gradiente-default ml-1'>
                                 <div className='spacing-flex1' style={{color: '#fff'}}><i className='pi pi-times-circle text-2xl' /><span className='ml-1' style={{fontSize:'1.5rem'}}>OffLine</span></div>
                                <div  style={{textAlign:'center'}}><span style={{fontSize:'3rem', fontWeight :'bold'}}>{offLine}</span></div>
                            </div>
                           

                       </div>
                    </div>

               </div>  
               <div className='flex flex-wrap '>
                <div className='col-12 md:col-8'>
                    <span style={{marginTop : '10px'}}># Alertas de suprimento abertos</span><br/>
                    
                        <div className='w-full flex flex-wrap'>
                            {
                            alertasSuprimentos && alertasSuprimentos.map(function(item, index){
                                return renderContentChip(item)
                            })
                        }
                        </div>
                    
                </div>
                <div className='col-12 md:col-4'>
                    <div className='pb-5 mt-5' >
                       <span style={{marginTop : '10px'}}># Produção de páginas (mês atual)</span>
                        <div className='flex flex-wrap '>
                           <div className='col-12 md:col-4 text-center'>
                                <span style={{fontSize: '0.6rem'}}>Mono</span><br/>
                                <span style={{fontSize: '2.1rem', fontWeight : 'bold'}}>{dataPainelProducao.producaoMono}</span>
                            </div> 
                            <div className='col-12 md:col-4 text-center'>
                                <span style={{fontSize: '0.6rem'}}>Color</span><br/>
                                <span style={{fontSize: '2.1rem', fontWeight : 'bold'}}>{dataPainelProducao.producaoColor}</span>
                            </div> 
                            <div className='col-12 md:col-4 text-center'>
                                <span style={{fontSize: '0.6rem'}}>Total</span><br/>
                                <span style={{fontSize: '2.1rem', fontWeight : 'bold'}}>{dataPainelProducao.producaoTotal}</span>
                            </div> 
                        </div>
                    </div>
                    <div className='pb-5 mt-5' >
                       <DashboardRevendaChatEquipamentos data={dataHistoricoEquipamentosLigados} /> 
                    </div>
                    <span style={{marginTop : '10px'}}># Suprimentos à terminar em 30 dias</span>
                    <div className='flex flex-wrap mt-2'>
                        {
                            dataPainelPrevisao ? dataPainelPrevisao.map(function(painel){
                                return <div className={'col-12 md:col-3  gradiente-'+painel.cor} style={{borderRadius:'5px 0px 0px 5px'}}>
                                <div style={{fontSize :'0.8rem', color: '#fff'}}>{painel.cor}</div>
                                <div style={{textAlign :'center'}}><span style={{fontSize :'3.5rem', color: '#fff'}}>{painel.total}</span></div>
                                <div style={{fontSize :'3.5rem', color: '#fff', textAlign:'center'}}>
                                    
                                </div>
                            </div>
                            }) : null
                        }
                                                       
                    </div>
                </div>
               </div>                            
            </div>
            
           
             <Toast ref={toast} />
        </Layout>
    );
}
